<template>
  <section v-if="offers?.length" class="skin-offers">
    <h2>{{ $t('Active offers') }}</h2>
    <div class="skin-offers_wrap">
      <div class="skin-offers_list g250 gap32">
        <OffersCard
            v-for="(item) of localeOffers"
            :key="`${item.market_name}-${item.price}`"
            :is-top="item.market_name === offers[0].market_name"
            :markets="markets"
            :name="name"
            :offer="item"
        />
      </div>
      <PaginateV2
          v-if="offers?.length > perPage"
          v-model="page"
          :pagesLength="Math.ceil(offers?.length / perPage)"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import {ref} from 'vue'
import type {MarketInfo, MarketOffer} from "~/graphql/generated/schema-types";
import OffersCard from "~/components/Pages/Item/Components/OffersCard.vue";

const props = defineProps<{
  offers: MarketOffer[]
  markets: MarketInfo[]
  name: string
}>()

const route = useRoute()

const perPage = ref(6)
const page = ref(route.query['offers'] === 'r' ? Math.ceil(props.offers?.length / perPage.value) : 1)

const localeOffers = computed(() => {
  const from = page.value * perPage.value - perPage.value
  const to = page.value * perPage.value
  return props.offers.slice(from, to)
})

</script>

<style lang="scss" scoped>


.paginate {
  padding: 3.2rem 0 0;

  &_wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
  }

  button {
    width: 4rem;
    height: 4rem;
    padding: 0;

    &.active {
      background: var(--accent-secondary);
      color: var(--accent-on-accent-secondary);
      //color: var(--accent-on-primary);
    }
  }
}


@media screen and (max-width: 480px) {
  .skin-offers {
    padding-bottom: 10px;
    overflow: hidden;
    margin: 3.2rem -1.6rem !important;

    h2 {
      margin-left: 1.6rem;
      margin-right: 1.6rem;
    }

    &_list {
      display: flex;
      gap: 1.6rem;
      overflow-x: auto;
      padding: 0 1.6rem;
    }
  }
}

</style>
